import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { CardOrientation, isRelativeUrl, Responsive, StyledCard } from '@/ui';
import { css } from '@emotion/core';
import { theme } from '../../../styles/theme';
import { Color } from '../../../styles/Color';
import { ICON_GAP_TRANSITION } from '../../../styles/animation/iconGapTransition';
import { RouterLink } from '../link/RouterLink';

interface IBaseCardProps {
	fullyClickable?: boolean;
	linkHref?: string;
	cardOrientation?: Responsive.IValueOrResponsiveValue<CardOrientation>;
	type?: 'blog' | 'feature';
	children: ReactNode;
}

export default function BaseCard({
	fullyClickable = true,
	linkHref,
	cardOrientation,
	type,
	children,
}: IBaseCardProps) {
	return fullyClickable && linkHref ? (
		<CardStyled
			fullyClickable={fullyClickable}
			cardOrientation={cardOrientation}
			type={type}
		>
			<StyledLink
				href={linkHref}
				target={!isRelativeUrl(linkHref) ? '_blank' : undefined}
			>
				<>{children}</>
			</StyledLink>
		</CardStyled>
	) : (
		<CardStyled
			fullyClickable={fullyClickable}
			cardOrientation={cardOrientation}
			type={type}
		>
			{children}
		</CardStyled>
	);
}

const StyledLink = styled(RouterLink)`
	text-decoration: none;
	color: ${Color.OnBackgroundText};
	display: flex;
	flex-direction: column;
	flex-grow: 1;
`;

const CardStyled = styled(StyledCard)<{
	fullyClickable: boolean;
	type?: 'blog' | 'feature';
}>`
	position: relative;
	flex-grow: 1;
	border-radius: ${theme.card?.borderRadius};
	margin-left: 0;

	${({ type, fullyClickable }) =>
		(type === 'blog' || !fullyClickable) &&
		css`
			box-shadow: none;
			&:hover {
				box-shadow: none;
			}
		`}

	${({ fullyClickable }) =>
		fullyClickable &&
		css`
			transition: transform 0.3s ease-out;

			&:hover {
				transform: translate(0px, -7px);

				h3 {
					color: ${theme.button?.secondary?.font?.color};
				}
			}
		`};

	svg {
		transition: ${`transform ${ICON_GAP_TRANSITION}`};
	}
`;
